module.exports = __webpack_public_path__ + "static/media/arrow-left.36f00da7.svg";